<!--
 * @Author: your name
 * @Date: 2020-05-28 10:42:50
 * @LastEditTime: 2020-06-09 09:47:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\website\src\views\customer\salary.vue
--> 
<template>
  <div class="customer_salary">
    <div class="salary_content">
      <div class="title">合作背景</div>
      <p class="writer">某在线教育平台兼职教师100人，平台每月营收流水1000万元，平均每名教师每月税前收入10万元。</p>
      <!-- 卡片 -->
      <div class="salary_card">
        <div class="card">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/customer/salary/card_1.png" />
        </div>
        <div class="vs">VS</div>
        <div class="card">
          <img src="https://taxlanderimages.oss-cn-shanghai.aliyuncs.com/assets/customer/salary/card_2.png" />
        </div>
      </div>
      <!-- 卡片 end-->
      <div class="end">通过云企惠提供的汇总申报方案，企业收到了6%的增值税专用发票，节省成本226.42万元，节省税负比高达90.57%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  components: {}
};
</script>
<style lang='less'>
.customer_salary {
  width: 100%;
  padding: 80px 0;
  box-sizing: border-box;
  .salary_content {
    width: 900/16rem;
    margin: 0 auto;
    text-align: center;

    .title {
      color: #999999;
      font-size: 20px;
    }
    .writer {
      color: #999999;
      font-size: 20px;

      margin: 20px 0 78px 0;
    }
    .salary_card {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;
      .card {
        img {
          width: 398px;
          height: 529px;
          background-size: 100% auto;
        }
      }
      .vs {
        color: var(--themeColor);
        font-size: 32px;
        margin: 0 12px;
      }
    }
    .end {
      color: var(--themeColor);

      font-size: 20px;
      margin: 80px 0;
      line-height: 30px;
    }
  }
}
</style>
